/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import { useMutation } from '@apollo/client';

import { SHARE_DIRECTORY_OR_FILE } from 'Apollo/Mutations/DataRecon';
import ShareFiles from '../components/ShareFiles';

const ShareFilesContainer = ({
    visible, setVisible, getDirDetails, fileExplorerDataSource, selectedFiles, parentDir, users, setToastMessage,
}) => {
    const [selectedUser, setSelectedUser] = useState('');
    const [userError, setUserError] = useState(false);

    const [shareFolderOrFile, { loading }] = useMutation(SHARE_DIRECTORY_OR_FILE);

    const filesToShare = [];

    selectedFiles && selectedFiles.forEach(file => {
        const result = fileExplorerDataSource && fileExplorerDataSource.find(element => element.id === file);
        if (result) {
            filesToShare.push(result);
        }
    });

    const fileOrFolderInput = filesToShare && filesToShare.map(item => ({ id: item.originalId, type: item.type }));

    const inputTypes = filesToShare && filesToShare.map(item => (item.type));

    const inputHandler = value => {
        setSelectedUser(value);
        if (!value) {
            setUserError(true);
        } else {
            setUserError(false);
        }
    };

    const onSave = async () => {
        setUserError(false);
        if (!selectedUser) {
            setUserError(true);
            return;
        }

        if (loading) {
            return;
        }

        await shareFolderOrFile({
            variables: {
                dirId: parentDir,
                sharedItems: fileOrFolderInput,
                sharedUserId: parseInt(selectedUser, 10),
            },
        }).then(() => {
            setToastMessage('Folders/Files are shared.');
        });
        setVisible(false);
        getDirDetails();
    };

    return (
        <ShareFiles
            visible={visible}
            setVisible={setVisible}
            selectedUser={selectedUser}
            userError={userError}
            inputHandler={inputHandler}
            onSave={onSave}
            users={users}
            inputTypes={inputTypes}
            loading={loading}
        />
    );
};

export default ShareFilesContainer;
